import { render, staticRenderFns } from "./Sms.vue?vue&type=template&id=72add608&"
import script from "./Sms.vue?vue&type=script&lang=ts&"
export * from "./Sms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports